export const TagType = Object.freeze({
	UNIT: 'UNIT',
	ORGANIZATION: 'ORGANIZATION',
	PERSON: 'PERSON',
});

export const TagTypeText = Object.freeze({
	[TagType.UNIT]: 'Unidade',
	[TagType.ORGANIZATION]: 'Organização',
	[TagType.PERSON]: 'Pessoa',
});